import BatchService from "common/services/BatchService";
import { DevelopmentStore } from "./DevelopmentStore";
import { CommonStore } from "common/CommonStore";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { Development } from "modules/development/models/Index";
import { default as firebase, firestore, storage } from "common/Firebase";
import defaultImagem from "common/assets/images/thumb-default.png";
import * as _ from "lodash";
import { LoginStore } from "modules/login/LoginStore";
import { WBSService } from "modules/WBS/WBSService";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBS } from "modules/WBS/models/WBS";
import { ProfileService } from "modules/profile/ProfileService";
import { LoginService } from "modules/login/LoginService";
import { now } from "utils/FirebaseUtils";
import { gtag } from "ga-gtag";

const removeProperty =
  (prop) =>
  ({ [prop]: _, ...rest }) =>
    rest;
const removeSharedUsers = removeProperty("sharedUsers");
const removeRefactorig = removeProperty("refactoring");
const removeUpdateFileConfig = removeProperty("updateFileConfig");

/**
 * Service de Projetos
 * @category Developments
 * @hideconstructor
 */
class DevelopmentService {
  private devSnapshot?: () => void;

  async getDevelopmentById(id) {
    this.clearDevSnapshot();
    this.devSnapshot = await firestore
      .collection("developments")
      .doc(id)
      .onSnapshot((snapshot) => {
        let data = snapshot.data();
        if (data) {
          let develop = new Development(
            data.name,
            data.address,
            data.status,
            data.users,
            data.createAt,
            data.modifyAt,
            data.image,
            data.imageName,
            data.ownerName,
            data.ownerPhoto,
            data.sharedUsers,
            data.version,
            data.isXeokitViewer,
            data.refactoring,
            data.updateFileConfig
          );
          DevelopmentStore.developmentName = data.name;
          DevelopmentStore.developmentSelected =
            new FirebaseDocument<Development>(snapshot.id, develop);
        } else {
          DevelopmentStore.developmentSelected =
            new FirebaseDocument<Development>("", Development.getDefault());
        }
      });
  }

  clearDevSnapshot() {
    if (this.devSnapshot) this.devSnapshot();
  }

  async setFavorite(favorite) {
    if (LoginStore.userAuth) {
      let id = LoginStore.userAuth.uid;
      let data = await firestore.collection("users").doc(id).get();
      let user = data.data();
      if (user) {
        LoginStore.userAuth.favorites.push(favorite);
        await firestore
          .collection("users")
          .doc(id)
          .update({ favorites: [...user.favorites, favorite] });
      }
    }
  }

  async unsetFavorite(favorite) {
    if (LoginStore.userAuth) {
      let id = LoginStore.userAuth.uid;
      let data = await firestore.collection("users").doc(id).get();
      let user = data.data();
      if (user) {
        let favorites = user.favorites,
          index = favorites.findIndex((item) => item === favorite);
        if (index !== -1) {
          favorites.splice(index, 1);
          LoginStore.userAuth.favorites = favorites;
          await firestore.collection("users").doc(id).update({ favorites });
        }
      }
    }
  }

  /**
   * Obtém a imagem salva na pasta images do Storage Firebase.
   * Utilizada para salvar as imagens de capa dos projetos e
   * as imagens de perfil dos Usuários.
   * @param {object} dev - Objeto contendo dados do projeto
   * @param {string} dev.imageName - Nome da imagem
   * @returns {Promise<string>} - URL de download da imagem
   */
  async getImage(dev): Promise<string> {
    try {
      var img = storage.ref(`images/${dev.imageName}`);
      let file = await img.getDownloadURL();
      return file;
    } catch (error) {
      console.log("error: ", error);
      return defaultImagem;
    }
  }

  /**
   * Faz o upload da imagem para a pasta images no Storage Firebase.
   * Utilizada para salvar as imagens de capa dos projetos e
   * as imagens de perfil dos Usuários.
   * @param {File} file - Arquivo
   * @param {string} id - Id do projeto ou id do usuário
   * @returns {Promise<void>}
   */
  async addImage(file, id): Promise<void> {
    await storage
      .ref()
      .child(`images/${id + file.name}`)
      .put(file);
  }
  async removeImage(file): Promise<void> {
    if (file) {
      try {
        await storage.ref().child(`images/${file}`).delete();
      } catch (error) {}
    }
  }
  async getCompanyImage(dev): Promise<string> {
    try {
      var img = storage.ref(`images/company/${dev.imageName}`);
      let file = await img.getDownloadURL();
      return file;
    } catch (error) {
      console.log("error: ", error);
      return defaultImagem;
    }
  }
  async addCompanyImage(file, id): Promise<void> {
    await storage
      .ref()
      .child(`images/company/${id + file.name}`)
      .put(file);
  }

  async setDevelopmentSelected(id): Promise<void> {
    await this.getDevelopmentById(id);
  }

  async getPositionDevelopment(developmentId) {
    const developments = await firestore
      .collection("wbsProjectBudget")
      .where("development", "==", developmentId)
      .get();
    return developments.docs.length;
  }

  /**
   * Esta função obtém com snapshot os projetos criados e compartilhados com o usuário logado
   * e processa os documentos: marcando aqueles que são favoritos, obtendo os dados dos usuários que possuim acesso à aquele projeto,
   * e por fim atualizando as listas no Store. Adicionando, alterando ou removendo nas seguintes listas:
   * developments, developmentsFavorites, developmentsSearch, developmentsFavoritesSearch.
   * @async
   * @todo Refatorar função separando responsabilidades
   * @returns {Promise<void>}
   */
  async fetchDevelopments(): Promise<void> {
    let checkDevelopmentView = DevelopmentStore.developments;
    try {
      let currentUser: any = await LoginStore.getAuthenticatedUserData();
      DevelopmentStore.currentUser = currentUser;
      if (LoginStore.userAuth != undefined) {
        let uid = ProfileService.getUserId();
        // Fetch proposals by brokers from proposals collection
        DevelopmentStore.developments = new Array();
        DevelopmentStore.developmentsSearch = new Array();
        DevelopmentStore.developmentsFavoritesSearch = new Array();
        LoginStore.clearDevelopmentsSnapshot();
        LoginStore.developmentsSnapshot = await firestore
          .collection("developments")
          .where(`users.${LoginStore.userAuth.uid}`, "<", 3)
          .onSnapshot(
            async (snapshot) => {
              for (let doc of snapshot.docChanges()) {
                if (doc.doc.id === null) throw new Error("doc.doc.id is null");

                let data: any = doc.doc.data();
                let develop = new Development(
                  data.name,
                  data.address,
                  data.status,
                  data.users,
                  data.ownerName,
                  data.ownerPhoto,
                  data.createAt,
                  data.modifyAt,
                  data.image,
                  data.imageName,
                  data.sharedUsers,
                  data.version,
                  data.isXeokitViewer,
                  data.refactoring,
                  data.updateFileConfig
                );
                let item = new FirebaseDocument<Development>(
                  doc.doc.id,
                  develop
                ) as any;
                let sharedUsers = (
                  await LoginService.fetchUsersByID(_.keys(item.data.users))
                ).filter(function (user) {
                  return user.email !== "" && user.uid !== uid;
                });

                if (sharedUsers.length > 0) {
                  item.data.sharedUsers = sharedUsers;
                }
                item.data.favorite =
                  LoginStore.userAuth != undefined
                    ? LoginStore.userAuth.favorites.indexOf(doc.doc.id) > -1
                    : false;
                if (doc.type === "added") {
                  await this.getUsersList(item, currentUser);
                  let field = ["data", "modifyAt", "seconds"],
                    compare = (a, b) => a < b;
                  CommonStore.pushSortingByField(
                    DevelopmentStore.developments,
                    item,
                    field,
                    compare
                  );
                  if (item.data.favorite)
                    CommonStore.pushSortingByField(
                      DevelopmentStore.developmentsFavorites,
                      item,
                      field,
                      compare
                    );
                  if (item.data.name.includes(DevelopmentStore.search)) {
                    CommonStore.pushSortingByField(
                      DevelopmentStore.developmentsSearch,
                      item,
                      field,
                      compare
                    );
                    if (item.data.favorite)
                      CommonStore.pushSortingByField(
                        DevelopmentStore.developmentsFavoritesSearch,
                        item,
                        field,
                        compare
                      );
                  }
                } else {
                  var ind = DevelopmentStore.developments.findIndex(
                    (dev) => dev.id === doc.doc.id
                  );
                  var indSearch = DevelopmentStore.developmentsSearch.findIndex(
                    (dev) => dev.id === doc.doc.id
                  );
                  var indFavorites =
                    DevelopmentStore.developmentsFavorites.findIndex(
                      (dev) => dev.id === doc.doc.id
                    );
                  var indFavoritesSearch =
                    DevelopmentStore.developmentsFavoritesSearch.findIndex(
                      (dev) => dev.id === doc.doc.id
                    );
                  if (ind !== -1) {
                    if (doc.type === "removed") {
                      DevelopmentStore.developments.splice(ind, 1);
                      if (indFavorites !== -1) {
                        DevelopmentStore.developmentsFavorites.splice(
                          indFavorites,
                          1
                        );
                      }
                      if (indSearch !== -1) {
                        DevelopmentStore.developmentsSearch.splice(
                          indSearch,
                          1
                        );
                        if (indFavoritesSearch !== -1)
                          DevelopmentStore.developmentsFavoritesSearch.splice(
                            indFavoritesSearch,
                            1
                          );
                      }
                    } else {
                      await this.getUsersList(item, currentUser);
                      if (DevelopmentStore.developments[ind]) {
                        DevelopmentStore.developments[ind] = item;
                      }
                      if (indFavorites !== -1) {
                        if (
                          DevelopmentStore.developmentsFavorites[indFavorites]
                        ) {
                          DevelopmentStore.developmentsFavorites[indFavorites] =
                            item;
                        }
                      }
                      if (indSearch !== -1) {
                        if (DevelopmentStore.developmentsSearch[indSearch]) {
                          DevelopmentStore.developmentsSearch[indSearch] = item;
                        }
                        if (indFavoritesSearch !== -1) {
                          if (
                            DevelopmentStore.developmentsFavoritesSearch[
                              indFavoritesSearch
                            ]
                          ) {
                            DevelopmentStore.developmentsFavoritesSearch[
                              indFavoritesSearch
                            ] = item;
                          }
                        }
                      }
                    }
                  }
                }
                if (DevelopmentStore.currentTab === 0)
                  DevelopmentStore.developmentsView =
                    DevelopmentStore.developmentsSearch;
                else
                  DevelopmentStore.developmentsView =
                    DevelopmentStore.developmentsFavoritesSearch;
              }

              if (checkDevelopmentView.length == 0) {
                DevelopmentStore.loading = false;
              }

              if (checkDevelopmentView.length == snapshot.size) {
                DevelopmentStore.loading = false;
              }
            },
            function (error) {
              DevelopmentStore.loading = false;
            }
          );
      }
    } catch (e) {
      console.log(e);
    }
  }

  async RemovAccessDevelopment(dev): Promise<void> {
    try {
      const devAnterior = dev;
      DevelopmentStore.developmentSelected = dev;
      let devRef = firestore.collection("developments").doc(dev.id);
      let data = await devRef.get();
      let userData = data.data();
      let arrayUpdate = {};
      if (userData) {
        if (LoginStore.userAuth) {
          let userAuthId = LoginStore.userAuth.uid;
          for (const [key, value] of Object.entries(userData.users)) {
            if (key != userAuthId) {
              arrayUpdate[key] = value;
            }
          }
        }
      }
      devRef.update({ users: arrayUpdate });

      if (devAnterior !== dev)
        DevelopmentStore.developmentSelected = devAnterior;
      else
        DevelopmentStore.developmentSelected =
          new FirebaseDocument<Development>("", Development.getDefault());
    } catch (e) {
      console.log("Error to unlinking Development: ", e);
      console.log(e);
    }
  }
  async DeleteDevelopment(dev): Promise<void> {
    const devAnterior = dev;
    try {
      DevelopmentStore.developmentSelected = dev;
      let devRef = firestore.collection("developments").doc(dev.id);

      BatchService.apply([{ type: "delete", args: [devRef] }]);

      if (devAnterior !== dev)
        DevelopmentStore.developmentSelected = devAnterior;
      else
        DevelopmentStore.developmentSelected =
          new FirebaseDocument<Development>("", Development.getDefault());
    } catch (e) {
      console.log("Error to delete Development: ", e);
      console.log(e);
    }
  }

  async RefactorAndOpen(dev): Promise<boolean> {
    let updateWbsRows = firebase
      .functions()
      .httpsCallable("convertProjectFormat", { timeout: 540000 });
    const updateResult = await updateWbsRows(dev);
    return updateResult.data;
  }

  /**
   * Esta função executa a cloud function responsável por copiar os dados do projeto passado por parâmetro.
   * Para isso ela faz uma verificação, pois se o projeto for de uma versão anterior a 2 é necessário refatorar primeiro.
   * Caso o retorno seja de sucesso, será percorrido a lista planos retornados e executado a função updateResourcesAfterCopy.
   * No final ela inscreve um snapshot em wbsCopyRows para deletar as linhas copiados com status de processed.
   * @async
   * @param {any} dev - Dados do projeto a ser copiado
   * @returns {Promise<any>}
   */
  async CopyDevelopment(dev): Promise<any> {
    return new Promise(async (resolve) => {
      let copyDevelopment: any = undefined;
      if (dev.data.version && dev.data.version == 2) {
        copyDevelopment = firebase
          .functions()
          .httpsCallable("copyDevelopment2", { timeout: 540000 });
      } else {
        DevelopmentStore.loadingWbsUpdate = true;
        const updateResult = await this.RefactorAndOpen(dev);
        DevelopmentStore.loadingWbsUpdate = false;

        if (!updateResult) {
          return; //Informar usuário que a cópia não foi efetuada
        }
        copyDevelopment = firebase
          .functions()
          .httpsCallable("copyDevelopment", { timeout: 540000 });
      }
      const resultCopy = await copyDevelopment(dev);
      const result = resultCopy.data;
      if (result.status !== "OK") {
        console.error("Falha ao copiar projeto:", result);
        resolve(result);
        return;
      }

      const { costPlans, newDevelopmentId } = result.data;
      let hasRowFromModelMap = false;
      if (costPlans) {
        costPlans.forEach((costPlan) => {
          if (
            costPlan.wbsRowIdsFromModelMap &&
            costPlan.wbsRowIdsFromModelMap.length
          ) {
            hasRowFromModelMap = true;
          }

          this.updateResourcesAfterCopy({
            data: {
              ...costPlan,
              newDevelopmentId,
            },
          });
        });
      }
      DevelopmentStore.loading = true;

      if (LoginStore.copyDevelopmentSnapshot)
        LoginStore.copyDevelopmentSnapshot();
      LoginStore.copyDevelopmentSnapshot = await firestore
        .collection("wbsCopyRows")
        .where(`projectName`, "==", dev.projectName)
        .onSnapshot(
          async (snapshot) => {
            for (let change of snapshot.docChanges()) {
              if (change.doc.id === null) throw new Error("doc.id is null");
              let data: any = change.doc.data();
              if (data.status !== "processed") return;
              DevelopmentStore.layerAdd = false;
              DevelopmentStore.needUpdateEapValues = true;
              DevelopmentStore.redirectId = newDevelopmentId;
              DevelopmentStore.clearDevelopmentCopied();
              firestore.collection("wbsCopyRows").doc(change.doc.id).delete();
              LoginStore.copyDevelopmentSnapshot = undefined;
              gtag("event", "duplicar_projeto", {
                duplicar_projeto: 0,
              });
            }
            resolve({ newDevelopmentId, hasRowFromModelMap });
            setTimeout(() => {
              WBSStore.changeDecimalAndRule();
            }, 1900);
          },
          function (error) {
            resolve(error);
            DevelopmentStore.layerAdd = false;
            DevelopmentStore.clearDevelopmentCopied();
          }
        );
    });
  }

  /**
   * Esta função executa a cloud function responsável por atualizar os recursos do plano de custo retornado na
   * função de cópia.
   * @async
   * @param {any} copyResult - Dados do plano de custo cópia
   */
  async updateResourcesAfterCopy(copyResult): Promise<void> {
    let updateResourcesQuantityTotal = firebase
      .functions()
      .httpsCallable("updateResourcesQuantityTotal", { timeout: 540000 });
    updateResourcesQuantityTotal(copyResult.data);
  }

  async AddDevelopment(name: string, address: string): Promise<string> {
    try {
      if (LoginStore.userAuth) {
        let dev = new Development(
          name,
          address,
          "open",
          { [LoginStore.userAuth.uid]: 0 },
          LoginStore.userAuth.displayName,
          LoginStore.userAuth.photoURL,
          now(),
          now(),
          "",
          "",
          undefined,
          undefined,
          true,
          true
        );
        dev.version = 2;

        const devRef = await firestore
          .collection("developments")
          .add(
            removeRefactorig(removeSharedUsers(removeUpdateFileConfig(dev)))
          );

        let wbs = await WBSService.createWBS(
          new WBS(
            name,
            0,
            40,
            devRef.id,
            2,
            "trunc",
            { percentual: 0, show: false },
            0,
            "Plano de custo 01",
            "",
            now(),
            true,
            0,
            {}
          )
        );
        gtag("event", "criacao_projeto", {
          criacao_projeto: 0,
        });

        return devRef.id;
      }
    } catch (e) {
      console.log("erro: ", e);
      console.log(e);
    }
    return "";
  }

  async EditAddress(id: string, address: string): Promise<string> {
    try {
      if (LoginStore.userAuth) {
        await firestore.collection("developments").doc(id).update({ address });
        return "";
      }
    } catch (e) {
      console.log("erro: ", e);
      console.log(e);
    }
    return "";
  }

  async changeDevelopmentImage(dev, file) {
    await this.removeImage(dev.data.imageName);
    await this.addImage(file, dev.id);
    let url = await this.getImage({ imageName: dev.id + file.name });
    await firestore
      .collection("developments")
      .doc(dev.id)
      .update({ imageName: dev.id + file.name, image: url });
  }

  async getUsersList(dev, currentUser?) {
    if (currentUser == undefined) {
      currentUser = DevelopmentStore.currentUser;
    }

    let userList: string = "";
    let uid: any = dev.data.users;
    let emailValue: any = [];
    for (let usrs in uid) {
      emailValue.push(await LoginStore.getSharedUser(usrs));
    }
    for (let index = emailValue.length - 1; index >= 0; index--) {
      if (emailValue[index] == undefined || currentUser == undefined) {
        continue;
      }
      if (emailValue[index].displayName == currentUser.displayName) {
        emailValue.splice(index, 1);
      } else {
        if (userList == "") {
          userList = emailValue[index].displayName.toString();
        } else {
          userList =
            userList + ",  " + emailValue[index].displayName.toString();
        }
      }
    }
    return (DevelopmentStore.shareUsersByDev[dev.id] = userList);
  }

  async changeDevelopmentName(dev, name) {
    await firestore.collection("developments").doc(dev.id).update({ name });
  }

  async updateSharedDatabase(users) {
    let uid = ProfileService.getUserId();
    var dev = DevelopmentStore.openShareDevelopment;
    if (!dev) return;

    dev.data.users = {};
    dev.data.users[uid] = 0;

    for (let index = 0; index < users.length; index++) {
      const element = users[index];

      dev.data.users[element] = 1;
    }

    await firestore
      .collection("developments")
      .doc(dev.id)
      .update({ users: dev.data.users });
  }

  public findOwnerInUsers(data: Development): string {
    let owner = "";
    if (data.users != undefined) {
      _.forEach(data.users, function (value, key) {
        if (value == 0) owner = key;
      });
    }
    return owner;
  }
}

const service = new DevelopmentService();
export { service as DevelopmentService };



// WEBPACK FOOTER //
// ./src/modules/development/DevelopmentService.ts